export class BoardActivityPanelState {
    isPanelOpen = false;
    isLoading = false;
    error: string | null = null;
    activities: BoardActivityItem[] = [];
    totalCount = 0;
    isFollowChangesOn = false;
    unseenCount = 0;
    latestRelevantActivityId: string | null = null;
    realtimeCountedActivityIds: string[] = [];
    realtimeAddedActivityIds: string[] = [];
    latestFollowedActivityId: string | null = null;
    // Operation ids of the `BoardActivitiesReceived` envelopes (one per MCP batch call) already processed in this
    // board session: a replayed envelope changes neither the badge nor the follow. No cap; not cleared by panel
    // open/close or acknowledgement (one GUID per received call).
    realtimeProcessedOperationIds: string[] = [];
}

export interface BoardActivityItem {
    id: string;
    type: number;
    userId: string;
    username: string;
    datetime: string;
    cardId: string;
    cardName: string;
    cardDescription: string;
    cardNumberOfChildren: number;
    parentCardId: string;
    parentCardName: string;
    releaseId: string;
    releaseName: string;
    releaseGoal: string;
    releaseStartDate: Date | null;
    releaseStartDateOldValue: Date | null;
    releaseReleaseDate: Date | null;
    releaseReleaseDateOldValue: Date | null;
    releaseIsReleased: boolean;
    statusId: number;
    statusName: string;
    originalContent: string;
    position: number;
    estimation: number;
    estimationUnit: string;
    externalToolName: string | null;
    attachmentId: string;
    attachmentName: string;
    cardColor: number;
    cardColorOldValue: number;
    cardColorLabel: string;
    cardColorLabelOldValue: string;
    content: string;
    cardPersonas: string;
    personaId: string;
    personaName: string;
    personaGroup: string;
    personaDescription: string;
    personaGoals: string;
    personaPictureId: string;
    // Rows written by one MCP batch call share the operation id (AF2); `operationIndex` is the card's input index.
    // Rows written before the batch tool, and by other writers, have neither.
    operationId?: string | null;
    operationIndex?: number | null;
}
